import styled from 'styled-components'

export const Container = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    width: 8.4rem;
    max-height: 30rem;
    padding-right: 1.96rem;
    top: 3.9rem;
    background-color: #fff;
    border: 1px solid #000;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 1;
`

export const OptionDiv = styled.div`
    display: flex;
    width: 8.4rem;
    justify-content: center;
    align-items: center;
    min-height: 2rem;
    max-height: 2rem;
    cursor: pointer;

    :hover{
        background-color: #EBEBEB;
    }
`

export const OptionText = styled.p`
    font-size: clamp(0.7rem, calc(0.7rem + 0.1vw) , 1.5rem);
    font-family: 'Inter', sans-serif;
`
